// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/material-kit-react.css?v=1.3.0
// module id = 9425
// module chunks = 0